import React, { useContext, useEffect, useState } from "react";
import MainTitle from "components/MainTitle";

import { Text } from "mondrian-react";
import Button from "components/Button";
import styled from "styled-components";
import InputControl from "components/InputControl";
import Input from "components/Input";
import {
  SendInvite,
  DeleteInvite,
  ResendInvite,
} from "core/api/dependenteApi/dependenteApi";
import Modal from "components/Modal";
import Analytics from "core/Utils/Analytics";
import { store } from "store.js";

export const Strong = styled.p`
  font-weight: bold;
`;
export const ActionButtons = styled.div`
  button {
    margin-right: 14px;
  }
`;
const DependentesConfirmPage = ({
  setForm,
  formData,
  navigation,
  setIsLoading,
  ...props
}) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { accesstoken } = state;

  let text = "";
  let subTitle = "";
  let service = null;
  const { go } = navigation;
  const [modalContent, setModalContent] = useState(null);

  function normalizeFlux(flux = "") {
    switch (flux) {
      case "remove":
        return "remover-dependente";
      case "resend":
        return "reenviar-convite";
      case "cancelInvite":
        return "cancelar-convite";
      case "add":
        return "adicionar-dependente";
      default:
        return flux;
    }
  }
  let title = "CPF do dependente";
  if (props.customData.flux === "remove") {
    subTitle = "Remover dependente";
    text = "Deseja realmente excluir o dependente abaixo?";
    service = DeleteInvite;
  } else if (props.customData.flux === "resend") {
    subTitle = "Reenviar convite";
    text = "Confira os dados antes de reenviar o convite:";
    service = ResendInvite;
  } else if (props.customData.flux === "cancelInvite") {
    subTitle = "Cancelar convite";
    text = "Deseja realmente cancelar o convite para o dependente abaixo?";
    service = DeleteInvite;
  } else if (props.customData.flux === "add") {
    subTitle = "Adicionar dependente";
    text = "Deseja realmente adicionar o dependente abaixo?";
    service = SendInvite;
  } else if (props.customData.flux === "selfremove") {
    subTitle = "Desvincular";
    text = "Deseja realmente deixar de ser dependente do titular abaixo?";
    title = "CPF do titular";
    service = DeleteInvite;
  }

  useEffect(
    function () {
      Analytics().setVirtualPageView(`/meuperfil/meus-numeros/${subTitle}`);
    },
    [subTitle]
  );

  const handleSendInvite = async function (data = null) {
    const { id, cpfCnpj, cpf } = props.customData;
    setIsLoading(true);
    const result = await service(
      { dependentId: cpfCnpj || cpf, id: id },
      accesstoken
    );
    setIsLoading(false);

    let { error = null } = result;
    if (error != null) {
      const { message } = error.warning;
      setModalContent(error);

      Analytics().setErrorEvent({
        eventAction: `callback:${normalizeFlux(props.customData.flux)}`,
        eventLabel: message,
        code: error?.errorCode
      });
      if (result.code === 401) {
        setTimeout(function () {
          window.location.href = process.env.REACT_APP_PING_AUTHORIZE;
        }, 2000);
      }
    } else {
      Analytics().setEvent({
        eventAction: `callback:${normalizeFlux(props.customData.flux)}`,
        eventLabel: "tentativa:sucesso",
      });
      go("success");
    }
  };

  function onRequestClose(data = {}) {
    setModalContent(null);
  }
  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <div>
        <MainTitle sm>Gerenciar meus números</MainTitle>
        <InputControl>
          <Strong className="mdn-Text">{subTitle}</Strong>
        </InputControl>
        <Text>{text}</Text>
        <div className="mdn-Link mdn-Link--arrow mdn-u-marginTop--xxs">
          <span>
            <i
              Style={"left: -5px;"}
              className="cred-icon-correction mdn-Icon-celular mdn-Icon--md cred-no-animation"
            ></i>
            {props.customData.msisdn} ({props.customData.segment})
          </span>
        </div>

        <div className="mdn-u-marginTop--sm mdn-u-marginBottom--sm">
          <Text>
            <Strong>{title}</Strong>
          </Text>
          <Strong className="mdn-Text">{props.customData.cpf || props.customData.cpfCnpj}</Strong>
        </div>
        <ActionButtons>
          <Button secondary onClick={() => go("listNumbers")}>
            Voltar
          </Button>
          <Button onClick={() => handleSendInvite("success")}>Concluir</Button>
        </ActionButtons>
      </div>
    </>
  );
};

export default DependentesConfirmPage;
